import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { Datepicker } from 'baseui/datepicker';
import { dateRangeFormStyles, datePickerContainerStyles } from './style';
import { DateFilter } from '../../types';

const DateRangeFilter = (props: any) => {
	const { onSubmit } = props;
	const [css] = useStyletron();
	const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
	const [selectedDate, setSelectedDate] = React.useState<Date>(yesterday);
	return (
		<>
			<div className={css(dateRangeFormStyles)}>
				<div className={css(datePickerContainerStyles)}>
					<Datepicker
						formatString='yyyy-MM-dd'
						maxDate={yesterday}
						value={selectedDate}
						onChange={({ date }) => setSelectedDate(date as Date)}
					/>
				</div>
				<div>
					<Button
						size='default'
						onClick={() => {
							const filterData: DateFilter = {
								selectedDate: selectedDate.getTime().toString()
							};
							onSubmit(filterData);
						}}>
						Apply Date Filter
					</Button>
				</div>
			</div>
		</>
	);
};

export default DateRangeFilter;
